module.exports = __webpack_public_path__ + "static/media/samvideo.8e9a0b04.jpg";